if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.container = this.closest('product-info');
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.quantityElement = document.getElementById(`Quantity-Form-${this.sectionId}`); 
      this.quantityInput = this.quantityElement?.querySelector('.quantity__input');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonPrice = this.submitButton.querySelector('.product__price');
      this.priceElement = this.submitButtonPrice?.querySelector('.price');
      this.regularPriceRegularElement = this.submitButtonPrice?.querySelector('.price__regular .price-item--regular');
      this.salePriceSaleElement = this.submitButtonPrice?.querySelector('.price__sale .price-item--sale');
      this.salePriceRegularElement = this.submitButtonPrice?.querySelector('.price__sale .price-item--regular');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityChanged.bind(this));
    }

    get variantsData() {
      if (!this.container) return [];
      return JSON.parse(this.container.querySelector('[data-variants]').textContent);
    }

    get currentVariantId() {
      if (!this.form) return '';
      return this.form.querySelector('[name=id]').value;
    }

    onQuantityChanged(event) {
      const quantity = event?.data.quantity || this.quantityInput?.value || 1;
      const source = event?.data.source || 'quantity-input';

      this.updateSubmitButtonPrices(quantity, source);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    updateSubmitButtonPrices(quantity, source) {
      if (this.submitButtonPrice === null) return;

      const currentVariant = this.variantsData.find((variant) => variant.id == this.currentVariantId);
      let price = currentVariant.price * quantity;
      let initialPrice = price;

      if (source === 'quantity-pack') {
        const selectedPack = document.querySelector('.quantity-pack__pack--selected');
        const reductionAmount = selectedPack?.dataset.reductionAmount || 0;
        price = price - (price * reductionAmount / 100);
      }
      
      if (this.regularPriceRegularElement) {
        this.regularPriceRegularElement.textContent = formatPrice(price);
        this.regularPriceRegularElement.dataset.price = price;
      }
      if (this.salePriceSaleElement) {
        this.salePriceSaleElement.textContent = formatPrice(price);
        this.salePriceSaleElement.dataset.price = price;
      }
      if (this.salePriceRegularElement) {
        this.salePriceRegularElement.textContent = formatPrice(initialPrice);
        this.salePriceRegularElement.dataset.price = initialPrice;
      }
      if (initialPrice > price) {
        this.priceElement.classList.add('price--on-sale');
      } else {
        this.priceElement.classList.remove('price--on-sale');
      }
    }
  });
}
